@if (showVideoPlayerDialog) {
  <app-pitchcard-video-player-modal
    [showVideoPlayerDialog]="showVideoPlayerDialog"
    [videoReviewId]="videoReviewId"
    (flagChange)="onModalFlag($event)"></app-pitchcard-video-player-modal>
}

@if (
  showContactMeDialog() ||
  showDoneDialog ||
  showContactInfoDialog ||
  showContactSwapDialog ||
  showSentDialog
) {
  <app-pitchcard-contact-dialogs
    [showContactMeDialog]="showContactMeDialog()"
    [showDoneDialog]="showDoneDialog"
    [showContactInfoDialog]="showContactInfoDialog"
    [showContactSwapDialog]="showContactSwapDialog"
    [showSentDialog]="showSentDialog"
    [isMobile]="isMobile"
    [isSearch]="isSearch"
    [isEmbedded]="isEmbedded"
    [isPortraitMode]="isPortraitMode"
    [userName]="userName"
    [currentPitchCard]="currentPitchCard"
    (flagChange)="onModalFlag($event)"
    (contactMenuClear)="
      closeLearnContactMenu()
    "></app-pitchcard-contact-dialogs>
}

@if (
  showViewReviewsDialog || showUploadReviewVideoDialog || showLearnAboutMeDialog
) {
  <app-pitchcard-video-reviews-modal
    [showViewReviewsDialog]="showViewReviewsDialog"
    [showUploadReviewVideoDialog]="showUploadReviewVideoDialog"
    [currentPitchCard]="currentPitchCard"
    [learnAboutMeReviews]="learnAboutMeReviews"
    (flagChange)="onModalFlag($event)"
    (playVideo)="reviewVideoInit($event)"
    (reviewsChange)="learnAboutMeReviews = $event"
    (businessRefresh)="
      currentPitchCard = pitchCardModalsWrapperService.getCurrentBusiness()
    "></app-pitchcard-video-reviews-modal>
}

@if (showMoreInfoDialog) {
  <app-pitchcard-more-info-modal
    [showMoreInfoDialog]="showMoreInfoDialog"
    [currentPitchCard]="currentPitchCard"
    [currentPitchCardType]="currentPitchCardType"
    [moreInfoWorkingHours]="moreInfoWorkingHours"
    [isEmbedded]="isEmbedded"
    [isMobile]="isMobile"
    [isPortraitMode]="isPortraitMode"
    [uniqueId]="uniqueId"
    (flagChange)="onModalFlag($event)"></app-pitchcard-more-info-modal>
}

@if (
  showJobDetailsDialog ||
  showJobRequirementsDialog ||
  showApplyJobDialog ||
  showApplyJobDialogByLink
) {
  <app-pitchcard-job-modals
    [showJobDetailsDialog]="showJobDetailsDialog"
    [showJobRequirementsDialog]="showJobRequirementsDialog"
    [showApplyJobDialog]="showApplyJobDialog"
    [showApplyJobDialogByLink]="showApplyJobDialogByLink"
    [currentPitchCard]="currentPitchCard"
    [benefits]="benefits"
    [workTypes]="workTypes"
    [workTypesList]="workTypesList"
    [locationAddress]="locationAddress"
    [compensationDescription]="compensationDescription"
    [isMobile]="isMobile"
    [mobileMode]="mobileMode"
    [jobCardScaleFactor]="jobCardScaleFactor"
    [scaleFactor]="scaleFactor"
    [userResumeCard]="userResumeCard"
    [validToApply]="validToApply"
    [uniqueId]="uniqueId"
    (flagChange)="onModalFlag($event)"></app-pitchcard-job-modals>
}

@if (showShareBusinessDialog) {
  <app-pitchcard-share-modal
    [showShareBusinessDialog]="showShareBusinessDialog"
    [shareTitle]="shareTitle"
    [shareBusinessUrl]="shareBusinessUrl"
    [currentPitchCard]="currentPitchCard"
    [isMobile]="isMobile"
    [isEmbedded]="isEmbedded"
    [isPortraitMode]="isPortraitMode"
    (flagChange)="onModalFlag($event)"
    (shareClosed)="setDefaultShareTitle()"></app-pitchcard-share-modal>
}

@if (showSelectPlanDialog) {
  <app-pitchcard-select-plan-modal
    [showSelectPlanDialog]="showSelectPlanDialog"
    [selectPlanBusinessId]="selectPlanBusinessId"
    [isMobile]="isMobile"
    (flagChange)="onModalFlag($event)"
    (planCleared)="
      selectPlanBusinessId = null
    "></app-pitchcard-select-plan-modal>
}

@if (
  showSaveMobileBusinessDialog || showSaveBusinessDialog || detailsPocketModal
) {
  <app-pitchcard-save-pocket-modal
    [showSaveMobileBusinessDialog]="showSaveMobileBusinessDialog"
    [showSaveBusinessDialog]="showSaveBusinessDialog"
    [detailsPocketModal]="detailsPocketModal"
    [isMobile]="isMobile"
    [isSearch]="isSearch"
    [mobilePocketScale]="mobilePocketScale"
    [currentPitchCard]="currentPitchCard"
    (flagChange)="onModalFlag($event)"
    (saveOpened)="onSaveBusinessOpened()"
    (requestContactSwap)="
      openContactSwapDialog()
    "></app-pitchcard-save-pocket-modal>
}

@if (showPhotoGalleriaDialog) {
  <app-pitchcard-photo-gallery-modal
    [showPhotoGalleriaDialog]="showPhotoGalleriaDialog"
    [photoGalleriaImages]="photoGalleriaImages"
    [activeGalleryIndex]="activeGalleryIndex"
    [isMobile]="isMobile"></app-pitchcard-photo-gallery-modal>
}

@if (showResumeFileDialog) {
  <app-pitchcard-resume-modal
    [showResumeFileDialog]="showResumeFileDialog"
    [currentPitchCard]="currentPitchCard"
    [isTablet]="isTablet"
    [isSearch]="isSearch"
    (flagChange)="onModalFlag($event)"></app-pitchcard-resume-modal>
}

@if (showLearnAboutMeDialog) {
  <app-pitchcard-learn-about-me-modal
    [showLearnAboutMeDialog]="showLearnAboutMeDialog"
    [currentPitchCard]="currentPitchCard"
    [learnAboutMeReviews]="learnAboutMeReviews"
    [isMobile]="isMobile"
    [isSearch]="isSearch"
    [googleMapLink]="googleMapLink"
    [scaleFactor]="scaleFactor"
    (flagChange)="onModalFlag($event)"
    (playVideo)="reviewVideoInit($event)"
    (reviewsCleared)="learnAboutMeReviews = []"
    (uploadReset)="resetReviewUpload()"
    (fileSelected)="
      uploadReviewVideo($event)
    "></app-pitchcard-learn-about-me-modal>
}
